<template>
  <div class="sections">
    <v-popover
      v-if="displayPopover"
      placement="top-start"
      :disabled="disabled"
      @update:open="displayModal"
    >
      <button v-once class="px-3">
        <font-awesome-icon :icon="['far', 'tag']" size="lg" class="text-60 hover-primary" />
      </button>
      <template #popover>
        <div class="popover-content">
          <SelectControl
            v-if="categories"
            class="popover-content__categories gray-select w-48"
            :options="formattedCategories"
            :multiple="true"
            :placeholder="$t('Select categories')"
            :html-labels="true"
            :value="checklist.categories"
            @input="handleSetCategories(arguments)"
          />
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
  import { eventBus } from '@/_legacy/eventBus';
  import SelectControl from '@/_legacy/components/Controls/SelectControl.vue';
  import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';

  export default {
    name: 'Categories',

    components: { SelectControl },

    props: {
      categories: {
        type: Array,
        required: true,
      },
      checklist: {
        type: Object,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      unavailable: {
        type: Boolean,
        default: false,
      }
    },

    computed: {
      formattedCategories() {
        return this.categories.map(category => ({
          value: category.value,
          label: `<span class="badge badge--purple">${category.label}</span>`,
        }));
      },

      displayPopover() {
        return this.categories && this.categories.length;
      },
    },

    methods: {
      displayModal() {
        if (!this.unavailable) {
          return;
        }
        eventBus.$emit('free-plan-limit', {
          message: {
            text: this.$t('This feature is not included in your free plan.'),
            advice: this.$t('Upgrade now to filter and analyze inspection results based on your categories.'),
          },
        });
      },
      handleSetCategories(e) {
        this.checklist.categories = e[0];
        trackClick(CLICK_EVENTS.SET_CATEGORY);
      }
    },
  };
</script>
